
import { gsap } from "gsap";
import { splitChars } from './utils';

const set = (element) => {

    // Splitto le lettere e animo l'intro
    const bigTitleIn = element.querySelector('.words-scroll__wrapper > *');

    if (bigTitleIn) {
        splitChars(bigTitleIn);

        gsap.set('.words-scroll__wrapper span', { y: '100%' });
    }
}

const play = () => {
    const bigTitleIn = document.querySelector('.words-scroll__wrapper > *');

    if (bigTitleIn) {

        gsap.to('.words-scroll__wrapper span', {
            y: '0%',
            duration: 1.6,
            ease: "quart.out",
            stagger: 0.05,
            delay: 1.6
        })
    }
}

export default { set, play };